import type { ReactNode } from "react";
import { Button } from "../components/button";
import { SheetContent, SheetDescription, SheetHeader, SheetTitle } from "../components/sheet";
import { Sheet } from "../components/sheet";
import { Typography } from "../components/typography";
import { cn } from "../lib/utils";

interface SheetLayoutProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: ReactNode;
}

export function SheetLayout({ open, onOpenChange, title, children }: SheetLayoutProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className={cn("sm:max-w-md pt-[84px]")}>
        <SheetHeader>
          <SheetTitle className="sr-only">Manage Member</SheetTitle>
          <SheetDescription className="sr-only">Manage the member's role and channels.</SheetDescription>
        </SheetHeader>
        <div className="flex items-center justify-between mb-6">
          <Typography size="md" font="unbounded">
            {title}
          </Typography>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            <i className="inline-block i-bp-close size-4" />
          </Button>
        </div>
        {children}
      </SheetContent>
    </Sheet>
  );
}
